<div class="his-select-file-local-media">
    @if (media().length > 0) {
    <his-plam
              [label]="'common.components.selectFile.localMedia.filter.property.name' | hisUi"
              helptext="common.components.selectFile.localMedia.filter.property.name.helptext"
              showLabelTop>
        <input
               #content
               type="text"
               [ngModel]="filterDraft()"
               (ngModelChange)="onFilterInput($event)"
               [ngModelOptions]="{ standalone: true }"
               (keydown.enter)="applyFilter()" />
    </his-plam>
    <div class="his-select-file-local-media__filter-actions">
        <button type="button" (click)="resetFilter()">
            {{ 'common.components.selectFile.localMedia.filter.reset' | hisUi }}
        </button>
    </div>

    <p-table
             #localMediaTable
             [value]="filteredMedia()"
             [paginator]="true"
             [first]="first()"
             [rows]="rowsPerPage()"
             [responsive]="true"
             (onPage)="onPage($event)">
        <ng-template pTemplate="header">
            <tr>
                <th class="smallestPossible">{{ 'common.components.selectFile.localMedia.select' | hisUi }}</th>
                <th>{{ 'common.components.selectFile.localMedia.name' | hisUi }}</th>
                @if (showCategory()) {
                <th class="smallestPossible">{{ 'common.components.selectFile.localMedia.category' | hisUi }}</th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td class="smallestPossible">
                    <button
                            type="button"
                            hisImage="ARROW_LEFT_FAT"
                            class="transparent"
                            (click)="selectionChange.emit(item)"
                            [title]="'common.selectOf' | hisUi: item.name"
                            [disabled]="disabled() || isSelected(item)"></button>
                </td>
                <td>
                    @if (downloadUrl(item); as url) {
                    <a
                       [href]="url"
                       class="link_download"
                       target="_blank"
                       rel="noopener"
                       [title]="'common.downloadOf' | hisUi: item.name">{{ item.name }}</a>
                    } @else {
                    {{ item.name }}
                    }
                    @if (showDescription() && item.description) {
                    <p><small>{{ item.description }}</small></p>
                    }
                </td>
                @if (showCategory()) {
                <td class="smallestPossible">{{ categoryLabel(item) }}</td>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="showCategory() ? 3 : 2">{{ 'de.his.faces.tags.table.datascroller.noRowsFound' |
                    hisUi }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <!--
                    The filter takes effect while typing, so the changed number of hits is the only
                    feedback a screen reader user gets. Announcing the count the paginator shows
                    anyway keeps that feedback free of text that is only there for them.
                -->
            <div role="status">
                <his-rows-per-page
                                   [resultRowsPerPage]="defaultPageSize"
                                   [rowsPerPage]="rowsPerPage()"
                                   (rowsPerPageChange)="onRowsPerPageChange($event); localMediaTable.reset()"
                                   [maxRows]="maxRowsPerPage"
                                   [totalRowCount]="filteredMedia().length"
                                   [currentPageNumber]="currentPageNumber()"
                                   [totalNumberOfPages]="totalNumberOfPages()"></his-rows-per-page>
            </div>
        </ng-template>
    </p-table>
    } @else if (mediaLoaded()) {
    <p class="his-select-file-local-media__empty">
        {{ 'common.components.selectFile.localMedia.noLocalMediaAvailable' | hisUi }}
    </p>
    }

    <button type="button" type="button" hisImage="PANEL_CLOSE" class="button_highlighted blue"
            (click)="cancelSelection.emit()">{{ 'common.cancel' | hisUi }}</button>
</div>